export default "__VITE_ASSET__D_gcYZ64__"